import { FC, MouseEvent, useRef, useState } from 'react';
import { useGesture } from 'react-use-gesture';

import CloseIcon from './CloseIcon';
import { PreviewImageBackground, PreviewImageContainer, PreviewImageStyled } from './PreviewImage.styled';

const defaultCropState = { x: 0, y: 0, scale: 1 };

export const PreviewImage: FC<{ src: string; onClose: () => void }> = ({ src, onClose }) => {
    const imageRef = useRef<HTMLImageElement>(null);
    const [crop, setCrop] = useState(defaultCropState);

    const handleClose = (event: MouseEvent<HTMLDivElement>) => event.currentTarget === event.target && onClose();

    useGesture(
        {
            onDrag: ({ offset: [dx, dy] }) => {
                setCrop(crop => ({ ...crop, x: dx, y: dy }));
            },
            onPinch: ({ offset: [d] }) => {
                d === 0 ? setCrop(defaultCropState) : setCrop(crop => ({ ...crop, scale: 1 + d / 50 }));
            }
        },
        {
            domTarget: imageRef,
            eventOptions: { passive: false },
            pinch: { enabled: true, distanceBounds: { min: 0, max: 200 } }
        }
    );

    return (
        <PreviewImageBackground onClick={handleClose}>
            <PreviewImageContainer onClick={handleClose}>
                <CloseIcon onClick={onClose} />
                <PreviewImageStyled
                    src={src}
                    ref={imageRef}
                    draggable="false"
                    style={{
                        left: crop.x,
                        top: crop.y,
                        transform: `scale(${crop.scale})`,
                        touchAction: 'none'
                    }}
                />
            </PreviewImageContainer>
        </PreviewImageBackground>
    );
};

PreviewImage.displayName = 'PreviewImage';
